export const LETRAS_STOP = "ABCDEFGHIJLMNOPQRSTUVXZ".split("");

export function normalizarRespostaStop(value = "") {
  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}

export function sortearLetraStop(usedLetters = [], random = Math.random) {
  const available = LETRAS_STOP.filter(
    (letter) => !usedLetters.includes(letter),
  );
  const pool = available.length ? available : LETRAS_STOP;
  return pool[Math.floor(random() * pool.length)];
}

export const limitarRespostaStop = (value = "") => value.slice(0, 25);

export const respostaStopPreenchida = (value = "") => value.trim().length > 0;

export const respostaStopComecaComLetra = (value = "", letter = "") =>
  value.trim().charAt(0).toUpperCase() === letter.toUpperCase();

export function respostasStopCompletas(answers = {}, categories = []) {
  return categories.every((category) =>
    respostaStopPreenchida(answers[category.id] || ""),
  );
}

export function contarRespostasStopValidas(
  answers = {},
  letter = "",
  categories = [],
) {
  return categories.filter((category) =>
    respostaStopComecaComLetra(answers[category.id] || "", letter),
  ).length;
}

export function progressoVotacaoStop(players = [], votes = {}, categoryId) {
  const needed = players.length * Math.max(players.length - 1, 0);
  const received = players.reduce((total, target) => {
    const categoryVotes = votes?.[target.id]?.[categoryId] || {};
    return (
      total +
      players.filter(
        (voter) =>
          voter.id !== target.id &&
          typeof categoryVotes[voter.id] === "boolean",
      ).length
    );
  }, 0);
  return {
    received,
    needed,
    complete: needed > 0 && received >= needed,
  };
}
